import { get, post, patch, formatUrl, deleteMethod } from '../../../utils/request'
import {
  GET_LIST_BANK,
  GET_LIST_MOMO,
  REQUEST_BANK_ACCOUNT,
  ADD_TOPUP,
  VERIFY_TOPUP,
  PAYMENT_TRANSFER,
  GET_LIST_TRANSACTION,
  GET_AVAILABLE_BALANCE,
  REQUEST_VISA_CARD,
  VERIFY_CARD_TOPUP
} from '../../../utils/urls'

function omitFrontendFlags (payload) {
  const { isCard, ...clean } = payload
  return clean
}

async function fetchAllPages (url, params) {
  let results = []
  let nextParams = { ...params, page: 1 }
  while (true) {
    const response = await get(url, nextParams)
    const data = response.data
    if (Array.isArray(data)) {
      return data
    }
    results = results.concat(data.results || [])
    if (!data.next) break
    nextParams.page = (nextParams.page || 1) + 1
  }
  return results
}

const actions = {

  requestGetListBank: async (context, payload) => {
    if (!payload || !payload.isMomo) {
      try {
        const results = await fetchAllPages(GET_LIST_BANK)
        context.commit('setListBank', results)
      } catch (e) {
        context.commit('setListBank', [])
      }
    } else {
      try {
        const results = await fetchAllPages(GET_LIST_MOMO)
        context.commit('setListMomo', results)
      } catch (e) {
        context.commit('setListMomo', [])
      }
    }
  },

  requestAddBankAccount: async (context, payload) => {
    return post(REQUEST_BANK_ACCOUNT, payload)
  },

  requestGetBankAccount: async (context, payload) => {
    let typeList = null
    try {
      let response
      if (!payload || !payload.is_momo) {
        response = await get(REQUEST_BANK_ACCOUNT, { employer_id: payload.currentBusinessAccount.id })
        typeList = 'setListBankAccount'
      } else {
        response = await get(REQUEST_BANK_ACCOUNT, { is_momo: true, employer_id: payload.currentBusinessAccount.id })
        typeList = 'setListMomoAccount'
      }
      if (response.status === 200) {
        const results = (response.data.results || []).filter(
          account => account.employer && account.employer.id === payload.currentBusinessAccount.id
        )
        context.commit(typeList, results)
      }
    } catch (e) {
      if (typeList) context.commit(typeList, [])
    }
  },

  requestPatchBankAccount: async (context, payload) => {
    const { id, ...data } = payload
    return patch(REQUEST_BANK_ACCOUNT + id + '/', data)
  },

  requestDeleteBankAccount: async (context, payload) => {
    return deleteMethod(REQUEST_BANK_ACCOUNT + payload.id + '/')
  },

  requestAddTopUp: async (context, payload) => {
    const isCard = !!payload.isCard
    const data = omitFrontendFlags(payload)
    const uri = isCard ? ADD_TOPUP + 'card/' : ADD_TOPUP
    return post(uri, data)
  },

  requestVerifyTopUp: async (context, payload) => {
    const isCard = !!payload.isCard
    const data = omitFrontendFlags(payload)
    const uri = isCard ? VERIFY_CARD_TOPUP : VERIFY_TOPUP
    return post(uri, data)
  },

  requestPaymentTransfer: async (context, payload) => {
    return post(PAYMENT_TRANSFER, payload)
  },

  requestGetListTransaction: async (context, payload) => {
    return get(GET_LIST_TRANSACTION, payload.params)
  },

  requestGetListCards: async (context) => {
    try {
      let response = await get(REQUEST_VISA_CARD)
      if (response.status === 200) {
        context.commit('setListVisaCards', response.data.results || [])
      }
    } catch (e) {
      context.commit('setListVisaCards', [])
    }
  },

  requestAddVisaCard: async (context, payload) => {
    return post(REQUEST_VISA_CARD, payload)
  },

  requestPatchVisaCard: async (context, payload) => {
    return patch(REQUEST_VISA_CARD + payload.id + '/', payload)
  },

  requestDeleteVisaCard: async (context, payload) => {
    return deleteMethod(REQUEST_VISA_CARD + payload.id + '/')
  },

  getAvailableBalance: async (context, payload) => {
    try {
      let url = formatUrl(GET_AVAILABLE_BALANCE, payload.params)
      let response = await get(url)
      if (response.status === 200) {
        context.commit('setAvailableBalance', response.data)
      }
    } catch (e) {
      context.commit('setAvailableBalance', null)
    }
  }
}

export default actions
